<template>
  <div
    :class="cardClass"
    class="flex w-fit items-center space-x-4 rounded-md border px-4 py-2 font-medium shadow-md"
  >
    <component :is="icon" :class="iconClass" class="h-6 w-6 shrink-0 fill-current" />
    <div :class="messageClass">
      <slot>{{ message }}</slot>
    </div>
  </div>
</template>

<script>
const config = {
  warning: {
    icon: 'SolidExclamationCircleIcon',
    cardClass: 'bg-yellow-100 border-yellow-400',
    iconClass: 'text-yellow-700',
    messageClass: 'text-yellow-700',
  },
  info: {
    icon: 'SolidInformationCircleIcon',
    cardClass: 'bg-blue-50 border-blue-300',
    iconClass: 'text-blue-700',
    messageClass: 'text-blue-700',
  },
}

export default {
  props: {
    message: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },

  computed: {
    icon() {
      return config[this.type].icon
    },
    cardClass() {
      return config[this.type].cardClass
    },
    iconClass() {
      return config[this.type].iconClass
    },
    messageClass() {
      return config[this.type].messageClass
    },
  },
}
</script>
